import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { ThemeProvider } from 'emotion-theming'
import { theme } from '../styles/theme'

import injectGlobalStyles from '../styles/global'

injectGlobalStyles()

const Wrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
`

const Layout = ({ children, data }) => (
  <ThemeProvider theme={theme}>
    <Wrapper>{children()}</Wrapper>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.func
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js